module.exports = __webpack_public_path__ + "static/media/customer-details.a374c33e.webp";